<template>
  <v-text-field
    :filled="!outlined"
    :outlined="outlined"
    :value="value"
    :label="label"
    :name="name"
    :type="type"
    :counter="counter"
    :hint="hint"
    :persistent-hint="persistentHint"
    :rules="rules"
    :disabled="disabled"
    :readonly="readonly"
    :hide-details="hideDetails"
    :error="error"
    :error-messages="errorMessages"
    color="primary"
    class="rounded-lg"
    :class="outlined ? 'app-text-field-outlined' : 'app-text-field-no-border'"
    @input="e => $emit('input', e)"
    @click="e => $emit('click', e)"
    @click:append="e => $emit('click:append', e)"
    @keyup="e => $emit('keyup', e)"
    @keydown="e => $emit('keydown', e)"
  >
    <template #prepend-inner v-if="prependInnerIcon">
      <v-icon color="primary" left>
        {{prependInnerIcon}}
      </v-icon>
    </template>
    <template #append v-if="appendIcon">
      <v-tooltip top v-if="appendIconTooltipText">
        <template v-slot:activator="{ on, attrs }">
            <v-icon 
              v-bind="attrs" 
              v-on="on" 
              color="primary" right
              @click=" $emit('click:append', e)"
            >{{appendIcon}}</v-icon>
        </template>
        <span>{{appendIconTooltipText}}</span>
      </v-tooltip>
      <v-icon v-else color="primary" right @click=" $emit('click:append', e)">
        {{appendIcon}}
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'AppTextField',

  props: {
    label: {
      type: String,
      default: ''
    },

    counter: {
      type: Boolean,
      default: false
    },
    value: {
      validator: function (value) {
      // Allow either String or null
        return (
          typeof value === 'string' ||
          value === null)
      },
      required: true,
      default: ''
    },

    name: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: 'text'
    },

    hint: {
      type: String,
      default: ''
    },

    persistentHint: {
      type: Boolean,
      default: false,
    },

    appendIcon: {
      type: String,
      default: ''
    },

    appendIconTooltipText: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: ''
    },

    prependInnerIcon: {
      type: String,
      default: ''
    },

    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    }
  }

}
</script>

<style>

  .app-text-field-no-border .v-text-field__slot,
  .app-text-field-no-border .v-input__prepend-inner,
  .app-text-field-no-border .v-input__slot {
    background-color: #FFFFFF !important;
  }

  .app-text-field-no-border  > div > .v-input__slot  {
    border: solid 1px;
    border-color: #66359B;
    color: transparent !important; 
    height: 60px !important;
  }

  .app-text-field-no-border.error--text  > div > .v-input__slot  {
    border-color: #ff3333 !important;
  }

  .app-text-field-no-border.v-input--is-disabled  > div > .v-input__slot {
    border-color: #c2c2c2 !important;
  }

  .app-text-field-no-border.v-input--is-disabled  > div > .v-input__slot > .v-text-field__slot > label{
    color: #c2c2c2 !important;
  }

  .app-text-field-no-border > .v-input__control > .v-input__slot::before {
      border: none !important;
  }

  .app-text-field-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-text-field__slot > label,
  .app-text-field-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-text-field__slot > label,
  .app-text-field-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > label,
  .app-text-field-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > label,
  .app-select-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > label,
  .app-select-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > label {
      color:  #66359B;
      font-weight: 600;
  }

  .app-text-field-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-text-field__slot > input,
  .app-text-field-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-text-field__slot > input,
  .app-text-field-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > input,
  .app-text-field-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > input,
  .app-select-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > .v-select__selection--comma,
  .app-select-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > .v-select__selection--comma {
      color:  #56565B !important;
  }

  .app-text-field-no-border > .v-input__control > .v-input__slot,
  .app-select-no-border > .v-input__control > .v-input__slot  {
    -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
    box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;

  }


</style>